// extracted by mini-css-extract-plugin
export default {"adLinks":"AdLinks_adLinks__KPGxh","styled":"AdLinks_styled__vqClc"};